import React from 'react';

import Stack from '../../Shared/UI/Stack/components/Stack';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import Button from '../../Shared/UI/Button/components/Button';
import styles from './JobProspectsStats.module.scss';

const JobProspectsStats = () => {
  return (
    <div className={styles.pageLayout}>
      <Stack gap="lg">
        <PageTitle text="Job Prospects Pipeline Stats" />
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <p>View statistics for each stage of the job prospects pipeline:</p>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginLeft: '1rem' }}>
            <Button 
              variant="ghost" 
              size="sm"
              onClick={() => window.location.href = '/job_prospects_stats/biopharma_groups'}
            >
              <strong>Biopharma Groups Stats</strong> - Companies and weblinks
            </Button>
            
            <Button 
              variant="ghost" 
              size="sm"
              onClick={() => window.location.href = '/job_prospects_stats/external_job_boards'}
            >
              <strong>External Job Boards Stats</strong> - Job board discovery and verification
            </Button>
            
            <Button 
              variant="ghost" 
              size="sm"
              onClick={() => window.location.href = '/job_prospects_stats/job_descriptions'}
            >
              <strong>Job Descriptions Stats</strong> - Job postings processing states
            </Button>
            
            <Button 
              variant="ghost" 
              size="sm"
              onClick={() => window.location.href = '/job_prospects_stats/match_scores'}
            >
              <strong>Match Scores Stats</strong> - User-job matching statistics
            </Button>
            
            <Button 
              variant="ghost" 
              size="sm"
              onClick={() => window.location.href = '/job_prospects_stats/job_prospects'}
            >
              <strong>Job Prospects Stats</strong> - Final prospects by status
            </Button>
            
            <Button 
              variant="ghost" 
              size="sm"
              onClick={() => window.location.href = '/job_prospects_stats/user_pipeline_debug'}
            >
              <strong>User Pipeline Debug</strong> - Per-user pipeline diagnostics
            </Button>

            <Button 
              variant="ghost" 
              size="sm"
              onClick={() => window.location.href = '/archived_job_prospects'}
            >
              <strong>Archived Job Prospects</strong> - Browse and unarchive archived prospects
            </Button>
          </div>
        </div>
      </Stack>
    </div>
  );
};

export default JobProspectsStats;
